import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Stack } from '@mui/material';
import useCompleteRegistration from '../useCompleteRegistration';
import Page from '../../../components/Page';
import CustomSnackbar from '../../../components/CustomSnackbar';
import CustomButton from '../../../components/CustomButton';
import Article from '../../../components/Article';
import ThemedTextField from '../../../components/ThemedTextField';
import MarketingConsentCheckbox from '../components/MarketingConsentCheckbox';
import { nameRule, phoneNumberRule } from '../validation';

const validationSchema = yup.object({
  name: nameRule,
  phoneNumber: phoneNumberRule,
});

const CompleteRegistrationLayout = () => {
  const { completeRegistration, loading, error } = useCompleteRegistration();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    if (error) {
      setSnackbarMessage(error.message);
      setSnackbarOpen(true);
    }
  }, [error]);

  const formik = useFormik({
    initialValues: {
      name: '',
      phoneNumber: '',
      marketingConsent: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      completeRegistration(values);
    },
  });

  return (
    <>
      <CustomSnackbar
        open={snackbarOpen}
        setOpen={setSnackbarOpen}
        message={snackbarMessage}
      />

      <Page>
        <Article title="Regisztráció kiegészítés" titleVariant="h5">
          {!error &&
            <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
              <Stack spacing={3}>
                <ThemedTextField
                  id="name"
                  name="name"
                  label="Név"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                />
                <ThemedTextField
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Telefonszám"
                  // A phone keypad on a phone, and the format spelled out rather than left to
                  // be guessed from an error message.
                  type="tel"
                  autoComplete="tel"
                  placeholder="+36 30 123 4567"
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                  helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                />
                <MarketingConsentCheckbox
                  checked={formik.values.marketingConsent}
                  onChange={formik.handleChange}
                />
                <CustomButton text="Tovább" type="submit" isLoading={loading} />
              </Stack>
            </form>
          }
        </Article>
      </Page>
    </>
  );
};

export default CompleteRegistrationLayout;